import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import './Navigation.css';

const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const navRef = useRef(null);

  // Handle scroll effect
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Toggle mobile menu
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Close mobile menu when clicking on a link
  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  // Handle navigation with smooth scroll
  const handleNavClick = (e, sectionId) => {
    e.preventDefault();
    closeMenu();
    
    if (location.pathname === '/') {
      // Already on home page, just scroll
      if (sectionId === 'home') {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } else {
        setTimeout(() => {
          const element = document.getElementById(sectionId);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
          }
        }, 50);
      }
    } else {
      // Navigate to home page first
      navigate('/');
      // Wait for the route to change and component to render
      setTimeout(() => {
        if (sectionId === 'home') {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
          const element = document.getElementById(sectionId);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
          } else {
            // If element not found, try again after a longer delay
            setTimeout(() => {
              const element = document.getElementById(sectionId);
              if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
              }
            }, 300);
          }
        }
      }, 100);
    }
  };

  return (
    <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
      <div className="nav-container">
        <Link to="/" className="nav-logo" onClick={closeMenu}>
          <img src={process.env.PUBLIC_URL + "/sk-logo.png"} alt="SK Logo" className="logo" />
          <span className="company-name">SK Dienstleistungen</span>
        </Link>
        <ul className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
          <li>
            <a href="#home" className="nav-link" onClick={(e) => handleNavClick(e, 'home')}>
            
              <span>Startseite</span>
            </a>
          </li>
          <li>
            <a href="#services" className="nav-link" onClick={(e) => handleNavClick(e, 'services')}>
            
              <span>Leistungen</span>
            </a>
          </li>
          <li>
            <a href="#blogs" className="nav-link" onClick={(e) => handleNavClick(e, 'blogs')}>
             
              <span>Über Uns</span>
            </a>
          </li>
          <li>
            <a href="#contact" className="nav-link" onClick={(e) => handleNavClick(e, 'contact')}>
             
              <span>Kontakt</span>
            </a>
          </li>
          <li>
            <a href="https://instagram.com/skdienstleistungen_" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Instagram">
              <i className="fab fa-instagram"></i>
            </a>
          </li>
          <li>
            <a href="mailto:info@dienstleistungensk.de" className="social-icon" aria-label="Email">
              <i className="fas fa-envelope"></i>
            </a>
          </li>
          <li>
            <a href="tel:01725443697" className="social-icon mobile-phone-icon" aria-label="Phone">
              <i className="fas fa-phone"></i>
            </a>
          </li>
        </ul>
        <div className={`nav-toggle ${isMenuOpen ? 'active' : ''}`} onClick={toggleMenu}>
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
